import type { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface CenteredLayoutProps {
  children: ReactNode;
  className?: string;
}

/**
 * Layout component that centers content with top margin.
 * Used for pages that need centered content presentation.
 */
export const CenteredLayout: FC<CenteredLayoutProps> = ({ children, className }) => (
  <div className={cn('mt-[4vh] flex w-full flex-col items-center', className)}>{children}</div>
);
